import styles from './BgRndVideo.module.css';

import bgVideo from '../../assets/video/bgRndVideo.webm';
import bgPoster from '../../assets/images/bgRndPoster.webp';

export const BgRndVideo = () => {
  return (
    <div className={styles.bgVideoWrapper}>
      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={bgPoster}
      >
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
